import PropTypes from 'prop-types'

// Utils
import { cn } from '@/utils/helpers'

function Card({ className, ...props }) {
  return (
    <div
      data-slot="card"
      className={cn(
        'bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm',
        className,
      )}
      {...props}
    />
  )
}

Card.propTypes = {
  className: PropTypes.string,
}

function CardHeader({ className = undefined, ...props }) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
        className,
      )}
      {...props}
    />
  )
}

CardHeader.propTypes = {
  className: PropTypes.string,
}

function CardTitle({ className = undefined, ...props }) {
  return (
    <div
      data-slot="card-title"
      className={cn('font-oswald text-primary text-xl leading-7 font-semibold', className)}
      {...props}
    />
  )
}

CardTitle.propTypes = {
  className: PropTypes.string,
}

function CardDescription({ className = undefined, ...props }) {
  return (
    <div
      data-slot="card-description"
      className={cn('text-sm leading-6 text-gray-500', className)}
      {...props}
    />
  )
}

CardDescription.propTypes = {
  className: PropTypes.string,
}

function CardAction({ className = undefined, ...props }) {
  return (
    <div
      data-slot="card-action"
      className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)}
      {...props}
    />
  )
}

CardAction.propTypes = {
  className: PropTypes.string,
}

function CardContent({ className = undefined, ...props }) {
  return <div data-slot="card-content" className={cn('px-6', className)} {...props} />
}

CardContent.propTypes = {
  className: PropTypes.string,
}

/**
 * CardFooter component
 * @param {Object} props - The properties for the CardFooter component.
 * @param {string} [props.className] - Additional class names to apply to the CardFooter.
 * @returns {import('react').JSX.Element} The rendered CardFooter component.
 */
function CardFooter({ className = undefined, ...props }) {
  return (
    <div
      data-slot="card-footer"
      className={cn('mt-8 flex justify-end border-t px-6 [.border-t]:pt-6', className)}
      {...props}
    />
  )
}

CardFooter.propTypes = {
  className: PropTypes.string,
}

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent }
